import { get, makeConstructUrlFromQuery } from './apiUtils';

const defaultUrl = '/generalDashboard/';

const getUrl = makeConstructUrlFromQuery(defaultUrl);

export default {
  getGeneralDashboard: ({ query } = {}) => get(getUrl({ query })),
};
